import store from "@/store";
import { PRIVILEGES } from "@/constants/privileges";

export default {
  install(Vue) {
    Vue.prototype.$privilege = (privilege) => {
      const userPrivileges = store.getters["user/privileges"];
      if (!userPrivileges) return false;
      return !!userPrivileges.find(
        ({ key: userPrivilege }) => userPrivilege === privilege
      );
    };
    // global mixins for common privileges check
    Vue.mixin({
      computed: {
        mxCanEdit() {
          return this.$privilege(PRIVILEGES.meeting.addEdit);
        },
        mxCanView() {
          return this.$privilege(PRIVILEGES.meeting.view);
        },
        mxCanVote() {
          return this.$privilege(PRIVILEGES.meeting.vote);
        },
        mxCanConfirm() {
          return this.$privilege(PRIVILEGES.meeting.confirm);
        },
        mxCanDocumentEdit() {
          return this.$privilege(PRIVILEGES.haldusnet.documentEdit);
        },
        mxCanForumEdit() {
          return this.$privilege(PRIVILEGES.haldusnet.forumEdit);
        },
        mxCanEditEntries() {
          return this.$privilege(PRIVILEGES.haldusnet.editEntries);
        },
        mxCanEditClosedEntries() {
          return this.$privilege(PRIVILEGES.haldusnet.editClosedEntries);
        },
        mxCanEditCooperatives() {
          return this.$privilege(PRIVILEGES.haldusnet.editCooperative);
        },
        mxCanEditApartment() {
          return this.$privilege(PRIVILEGES.haldusnet.editApartment);
        },
        mxCanEditBuildingCooperatives() {
          return this.$privilege(PRIVILEGES.haldusnet.buildingCooperative);
        },
        mxEditCooperativeApartment() {
          return this.$privilege(PRIVILEGES.haldusnet.buildingCooperative);
        },
        mxViewApartmentMeasurer() {
          return this.$privilege(PRIVILEGES.haldusnet.viewApartmentMeasurer);
        },
        mxViewApartmentInvoice() {
          return this.$privilege(PRIVILEGES.haldusnet.boardInvoice);
        },
        mxResidentView() {
          return this.$privilege(PRIVILEGES.haldusnet.boardResidents);
        },
        mxBoardMeasurers() {
          return this.$privilege(PRIVILEGES.haldusnet.boardMeasurers);
        },
        mxRoleAdmin() {
          return this.$privilege(PRIVILEGES.haldusnet.roles);
        },
        mxPrivilegeAdmin() {
          return this.$privilege(PRIVILEGES.haldusnet.privilege);
        },
        mxViewBuilding() {
          return this.$privilege(PRIVILEGES.haldusnet.viewBuilding);
        },
        mxViewApartment() {
          return this.$privilege(PRIVILEGES.haldusnet.viewApartment);
        },
        mxViewGroups() {
          return this.$privilege(PRIVILEGES.haldusnet.cooperativeBuildingView);
        },
        mxResidentEdit() {
          return this.$privilege(PRIVILEGES.haldusnet.cooperativeResidentEdit);
        },
        mxPersonsEdit() {
          return this.$privilege(PRIVILEGES.haldusnet.cooperativePersonsEdit);
        },
        mxUserEdit() {
          return this.$privilege(PRIVILEGES.haldusnet.userEdit);
        },
        mxCanViewGeneral() {
          return this.$privilege(PRIVILEGES.haldusnet.view);
        },
        mxCanViewCooperatives() {
          return this.$privilege(PRIVILEGES.haldusnet.viewCooperative);
        },
        mxCanEditEntriesUnlimited() {
          return this.$privilege(
            PRIVILEGES.haldusnet.coopertaiveMeasurerEntriesEditUnlimited
          );
        },
        mxCanCooperativeResidentInvoicePreferences() {
          return this.$privilege(
            PRIVILEGES.haldusnet.cooperativeResidentInvoicePreferences
          );
        },
      },
    });
  },
};
